import React, {useEffect, useReducer, useState} from "react";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button"
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import Loader from "@amzn/meridian/loader";
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import Pagination from "@amzn/meridian/pagination";
import {FormattedMessage} from "react-intl";
import SearchField from "@amzn/meridian/search-field";
import {DriverPackageSummaryReducer} from "./reducer/DriverPackageSummaryReducer";
import {
    DRIVER_ASSIGNED_TRACKING_ID_LIST,
    DRIVER_ATTRIBUTES, DRIVER_COUNT_HEADER, DRIVER_ID, DRIVER_NAME,
    DRIVER_PACKAGE_SUMMARY,
    FETCH_FROM_CACHE,
    FILTER_DATA,
    PAGE_SIZE, PRINT_DA_BUTTON_MESSAGE_ID,
    PRINT_DRIVER_PACKAGE_SUMMARY, PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON,
    PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_DISABLE_KEY, PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_INVOKED,
    PRINT_DRIVER_PACKAGE_SUMMARY_DISABLE_TIME, PRINT_DRIVER_PACKAGE_SUMMARY_FILE_NAME,
    REFRESH_BUTTON,
    REFRESH_BUTTON_DISABLE_KEY,
    REFRESH_BUTTON_DISABLE_TIME,
    REFRESH_BUTTON_INVOKED, REFRESH_BUTTON_MESSAGE_ID, STATION_COUNT, STATION_COUNT_HEADER,
    STATION_LEVEL_ATTRIBUTES, STATION_LEVEL_HEADER_NAME, TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON,
    TOGGLE_REFRESH_BUTTON,

} from "./constants/DriverPackageSummaryConstants";
import {TrackingIdListDialog} from "./TrackingIdListDialog";
import {DriverAssignedTrackingIdListReducer} from "./reducer/DriverAssignedTrackingIdListReducer";
import {useLocalStorage} from "./LocalStorage";
import {useTimeLeft} from "./TimeLeft";
import {PrintDriverPackageSummaryReducer} from "./reducer/PrintDriverPackageSummaryReducer";
import { CSVLink } from 'react-csv';

const initialStateDriverPackageSummary = {
    stationCount:[],
    driversCount: [],
    filteredDriversCount: [],
    loading: false,
    success: false,
    enableRefreshButton: true,
    refreshButtonAlertType: "none",
    refreshButtonAlertMessage: "none"
};


const initialStateDriverAssignedTrackingId = {
    driverAssignedTrackingId:{},
    isLoading: false,
    requestCompleted: false,
};

const initialStatePrintDriverPackageSummary = {
    printDriverPackageSummaryData: [],
    printDriverPackageLoading: false,
    printDriverPackageSuccess: false,
    enablePrintDriverPackageSummaryButton: true,
    printDriverPackageAlertType: "none",
    printDriverPackageAlertMessage: "none"
};

export const DriverPackageSummary = (props) => {
    const [{stationCount, filteredDriversCount, loading, success, enableRefreshButton, refreshButtonAlertType, refreshButtonAlertMessage}, dispatch] = useReducer(DriverPackageSummaryReducer, initialStateDriverPackageSummary);
    const [{printDriverPackageSummaryData,printDriverPackageSuccess, enablePrintDriverPackageSummaryButton, printDriverPackageAlertType, printDriverPackageAlertMessage}, dispatchPrintDriverPackage] = useReducer(PrintDriverPackageSummaryReducer, initialStatePrintDriverPackageSummary);
    const [{driverAssignedTrackingId, requestCompleted}, dispatchDriverAssignedTrackingId] = useReducer(DriverAssignedTrackingIdListReducer, initialStateDriverAssignedTrackingId);
    const [refreshButtonDisabledTime, setRefreshButtonDisabledTime] = useLocalStorage(REFRESH_BUTTON_DISABLE_KEY, new Date().getTime());
    const [printDriverPackageDisabledTime, setPrintDriverPackageDisabledTime] = useLocalStorage(PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_DISABLE_KEY, new Date().getTime());
    const refreshButtonDisabledMinutes = useTimeLeft(parseInt(refreshButtonDisabledTime, 10));
    const printDriverPackageSummaryDisabledMinutes = useTimeLeft(parseInt(printDriverPackageDisabledTime, 10));
    const [openTrackingIdListDialog, setopenTrackingIdListDialog] = useState(false);
    const [selectedColumn, setSelectedColum] = useState("");
    const [query, setQuery] = useState("")
    const [currentPage, setCurrentPage] = useState(1);
    const [refreshButtonMessage, setRefreshButtonMessage] = useState(REFRESH_BUTTON)
    const [printDASheetButtonMessage, setPrintDAPackageSheetButtonMessage] = useState(PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON)
    const pageCount = Math.ceil(filteredDriversCount.length/PAGE_SIZE);
    const csvLink = React.useRef();

    const currentPagePackages = filteredDriversCount
        .slice( (currentPage - 1)*PAGE_SIZE, currentPage*PAGE_SIZE );

    useEffect(() => {
        dispatch({
            type: FETCH_FROM_CACHE
        })
    });

    useEffect(() => {
        dispatch({
            type: FILTER_DATA,
            data: {prefix: query}
        })
        setCurrentPage(1)
    }, [query]);

    useEffect(() => {
        if (printDriverPackageSuccess) {
            const currentTime = new Date().getTime();
            setPrintDriverPackageDisabledTime(JSON.stringify((new Date(currentTime + PRINT_DRIVER_PACKAGE_SUMMARY_DISABLE_TIME).getTime())));
        }
    }, [printDriverPackageSuccess])

    useEffect(() => {
        if (success) {
            const currentTime = new Date().getTime();
            setRefreshButtonDisabledTime(JSON.stringify((new Date(currentTime + REFRESH_BUTTON_DISABLE_TIME).getTime())));
        }
    }, [success])

    useEffect(() => {
        const remainingTime = (refreshButtonDisabledTime - new Date().getTime());
        if (remainingTime >= 0 && remainingTime <= REFRESH_BUTTON_DISABLE_TIME && enableRefreshButton) {
            setRefreshButtonMessage(REFRESH_BUTTON_INVOKED.replace("X", refreshButtonDisabledMinutes))
            dispatch({type: TOGGLE_REFRESH_BUTTON})
            setTimeout(function () {
                dispatch({type: TOGGLE_REFRESH_BUTTON})
                setRefreshButtonMessage(REFRESH_BUTTON)
            }, remainingTime);
        } else if (remainingTime >= 0 && remainingTime <= REFRESH_BUTTON_DISABLE_TIME) {
            setRefreshButtonMessage(REFRESH_BUTTON_INVOKED.replace("X", refreshButtonDisabledMinutes))
        }

    })

    useEffect(() => {
        const remainingTime = (printDriverPackageDisabledTime - new Date().getTime());
        if (remainingTime >= 0 && remainingTime <= PRINT_DRIVER_PACKAGE_SUMMARY_DISABLE_TIME &&
            enablePrintDriverPackageSummaryButton) {
            if (printDriverPackageSuccess) {
                csvLink.current.link.click()
            }
            setPrintDAPackageSheetButtonMessage(PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_INVOKED.replace("X", printDriverPackageSummaryDisabledMinutes))
            dispatchPrintDriverPackage({type: TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON})
            setTimeout(function () {
                dispatchPrintDriverPackage({type: TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON})
                setPrintDAPackageSheetButtonMessage(PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON)
            }, remainingTime);
        } else if (remainingTime >= 0 && remainingTime <= PRINT_DRIVER_PACKAGE_SUMMARY_DISABLE_TIME) {
            setPrintDAPackageSheetButtonMessage(PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON_INVOKED.replace("X", printDriverPackageSummaryDisabledMinutes))
        }

    })

    const onSubmit = () => {
        dispatch({
            type: FILTER_DATA,
            data: {prefix: query}
        })
        setCurrentPage(1)
    };

    const onClickRefreshDataButton = () => {
        dispatch({
            type: DRIVER_PACKAGE_SUMMARY,
            data: {dispatcher: dispatch}
        })
    };

    const onClickPrintDriverPackageSummaryButton = () => {
        dispatchPrintDriverPackage({
            type: PRINT_DRIVER_PACKAGE_SUMMARY,
            data: {dispatcher: dispatchPrintDriverPackage}
        })
    }

    const openTIdListDialog = (driverId, columnName) => {

        dispatchDriverAssignedTrackingId({
            type: DRIVER_ASSIGNED_TRACKING_ID_LIST,
            data: {driverId:driverId, dispatcher: dispatchDriverAssignedTrackingId}
            })
        setopenTrackingIdListDialog(true);
        setSelectedColum(columnName)
    }

    if (loading) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Loader type="circular"/>
        </Row>)
    }

    return (
            <Column spacingInset="small large">
                {
                    printDriverPackageAlertType!=="none"?<div className="alert-message">
                        <Alert type={printDriverPackageAlertType} size="medium" width="100%" >
                            {printDriverPackageAlertMessage}
                        </Alert>
                    </div>:null
                }
                {
                    refreshButtonAlertType!=="none"?<div className="alert-message">
                        <Alert type={refreshButtonAlertType} size="medium" width="100%" >
                            {refreshButtonAlertMessage}
                        </Alert>
                    </div>:null
                }

                <Box>
                    <Box>
                        <Row width="100%"  spacing="small" spacingInset="none">
                            <Column width="80%">
                                <SearchField
                                    value={query}
                                    onChange={setQuery}
                                    placeholder="Search for driver..."
                                    onSubmit={onSubmit}
                                    clearButton={true}
                                />
                            </Column>
                            <Column>
                                <Row alignmentHorizontal="right">
                                    <Button onClick={onClickPrintDriverPackageSummaryButton} type="tertiary" disabled={!enablePrintDriverPackageSummaryButton}>
                                        <FormattedMessage id={PRINT_DA_BUTTON_MESSAGE_ID} defaultMessage={printDASheetButtonMessage}/></Button>
                                    <CSVLink  data={printDriverPackageSummaryData} ref={csvLink} filename={PRINT_DRIVER_PACKAGE_SUMMARY_FILE_NAME} target="_blank" fileEncoding="UTF-8"/>
                                </Row>
                            </Column>
                            <Column>
                                <Row alignmentHorizontal="right">
                                    <Button onClick={onClickRefreshDataButton} type="tertiary"  disabled={!enableRefreshButton}>
                                        <FormattedMessage id={REFRESH_BUTTON_MESSAGE_ID} defaultMessage={refreshButtonMessage}/>
                                    </Button>
                                </Row>

                            </Column>
                        </Row>


                        <Table headerRows={0} spacing="small">
                            <TableRow key={STATION_COUNT_HEADER}>
                                <TableCell><b>
                                    {STATION_LEVEL_HEADER_NAME}
                                </b>
                                </TableCell>
                                {
                                    STATION_LEVEL_ATTRIBUTES.map(([key, columnName], index) => {
                                            return (
                                                <TableCell>
                                                    <b>{columnName}</b>
                                                </TableCell>);
                                    })
                                }
                            </TableRow>
                            <TableRow key={STATION_COUNT}>
                                <TableCell></TableCell>
                                {
                                    STATION_LEVEL_ATTRIBUTES.map(([key], index) => {
                                        return (
                                            <TableCell>
                                                {stationCount[key]}
                                            </TableCell>);
                                    })
                                }
                            </TableRow>
                            <TableRow key={DRIVER_COUNT_HEADER}>
                                {
                                    DRIVER_ATTRIBUTES.map(([key, columnName], index) => {
                                            return (
                                                <TableCell key={key}>
                                                    <b>{columnName}</b>
                                                </TableCell>);
                                    })
                                }
                            </TableRow>
                            {currentPagePackages.map((item, index) => (
                                <TableRow key={item.driverName}>
                                    {
                                        DRIVER_ATTRIBUTES.map(([key, columnName], index) => {
                                            if (key === DRIVER_NAME || item[key] === 0) {
                                                return (
                                                    <TableCell key={item[key]}>
                                                        {item[key]}
                                                    </TableCell>);
                                            } else {
                                                return (
                                                    <TableCell key={item[key]}>
                                                        <a href="#none" key={index} onClick={() => openTIdListDialog(item[DRIVER_ID], key)}>
                                                            {item[key]}
                                                        </a>
                                                    </TableCell>);
                                            }

                                        })
                                    }
                                </TableRow>
                            ))}
                        </Table>
                    </Box>
                    {openTrackingIdListDialog && requestCompleted &&<TrackingIdListDialog isModalOpen={openTrackingIdListDialog} onModelOpenChange={setopenTrackingIdListDialog}
                                                                       trackingIdList={driverAssignedTrackingId[selectedColumn]}/>}
                    <Row width="100%" widths="fill" >
                        <Box>
                            <Text type="b200" >
                                Showing { Math.min((currentPage - 1)*PAGE_SIZE + 1 , filteredDriversCount.length)} to {Math.min((currentPage - 1)*PAGE_SIZE + PAGE_SIZE, filteredDriversCount.length)} of {filteredDriversCount.length}
                            </Text>
                        </Box>
                        <Row alignmentHorizontal="right" >
                            { (pageCount > 1) && <Pagination
                                numberOfPages={pageCount}
                                onChange={ (e) => {
                                    setCurrentPage(e)
                                }}
                                currentPage={currentPage}
                            />
                            }
                        </Row>
                    </Row>
                </Box>
            </Column>
    )
};


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/driverPackageSummary.js